import { SimpleChanges, TemplateRef, ViewContainerRef, } from '@angular/core';
import { HoldingsDatePickerDirective } from 'SecuritiesApp/ts/directives/holdings-date-picker.directive';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i3 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _c0 = ["templateRef"];
const _c1 = a0 => ({ "disabled": a0 });
const _c2 = () => ({ button: "btn dropdown-toggle" });
function HoldingsDatePickerInlineComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "button", 2);
    i0.ɵɵlistener("click", function HoldingsDatePickerInlineComponent_ng_template_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.prevDate()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 1)(4, "ycn-single-select-dropdown", 4);
    i0.ɵɵlistener("changeHandler", function HoldingsDatePickerInlineComponent_ng_template_0_Template_ycn_single_select_dropdown_changeHandler_4_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectMonthHandler($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ycn-single-select-dropdown", 5);
    i0.ɵɵlistener("changeHandler", function HoldingsDatePickerInlineComponent_ng_template_0_Template_ycn_single_select_dropdown_changeHandler_5_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectYearHandler($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 1)(7, "button", 6);
    i0.ɵɵlistener("click", function HoldingsDatePickerInlineComponent_ng_template_0_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.nextDate()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c1, ctx_r1.disablePrev || ctx_r1.inputDisabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-back");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(14, _c2))("selectedValue", ctx_r1.selectedMonth)("config", ctx_r1.monthDropdownConfig)("inputDisabled", ctx_r1.inputDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(15, _c2))("selectedValue", ctx_r1.selectedYear)("config", ctx_r1.yearDropdownConfig)("inputDisabled", ctx_r1.inputDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c1, ctx_r1.disableNext || ctx_r1.inputDisabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-collapse");
} }
/**
 * HoldingsDatePickerInlineComponent
 *
 * This component allows the user to select a MM/YY date. (Only month and year, no specific day, can be selected).
 * Only a specified set of dates will be shown for the user to select. This is useful
 * in cases where we want to restrict selection to a small of valid date options. This component also allows
 * the user to navigate to the next and previous valid date options with arrow buttons
 *
 * Input Properties:
 *   dateOptions: list of Date() options for the date picker to display for selection
 *   initialSelectedDate: Date that will be initially selected by the date picker
 *
 * Output Properties:
 *   dateChangeHandler: Emits the newly selected year and month whenever a new date is selected
 */
export class HoldingsDatePickerInlineComponent extends HoldingsDatePickerDirective {
    constructor(viewContainerRef) {
        super();
        this.viewContainerRef = viewContainerRef;
        this.inputDisabled = false;
    }
    ngOnInit() {
        super.ngOnInit();
        if (!this.initialSelectedDate)
            return;
        const initialYear = this.initialSelectedDate.getFullYear();
        const initialMonth = this.initialSelectedDate.getMonth();
        // If initialSelectedDate is not a valid date option, keep latest valid date as initial selection
        if (!this.sortedYears.includes(initialYear) || !this.yearsToMonthsMapping[initialYear].includes(initialMonth))
            return;
        this.selectedYear = initialYear;
        this.selectedMonth = initialMonth;
        this.setMonthDropdownConfig();
        this.checkArrowButtons();
        // We need to embed the template of this component and remove the 'ycn-' tag so that the view exists
        // outside of the component's host view, and thus outside of the component selector. Otherwise,
        // the DOM structure messes with the intended css styles, such as 'first-child' and 'last-child' logic.
        this.viewContainerRef.createEmbeddedView(this.templateRef);
        document.querySelectorAll('ycn-holdings-date-picker-inline').forEach((elt) => {
            elt.parentNode.removeChild(elt);
        });
    }
    ngOnChanges(changes) {
        // eslint-disable-next-line no-prototype-builtins
        if ('initialSelectedDate' in changes) {
            // in the case that initialSelectedDate member is changed in the outer component
            // @ts-ignore
            const newInitialSelectedDate = changes.initialSelectedDate.currentValue;
            this.selectedYear = newInitialSelectedDate.getFullYear();
            this.selectedMonth = newInitialSelectedDate.getMonth();
        }
    }
}
HoldingsDatePickerInlineComponent.ɵfac = function HoldingsDatePickerInlineComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsDatePickerInlineComponent)(i0.ɵɵdirectiveInject(i0.ViewContainerRef)); };
HoldingsDatePickerInlineComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsDatePickerInlineComponent, selectors: [["ycn-holdings-date-picker-inline"]], viewQuery: function HoldingsDatePickerInlineComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, inputs: { inputDisabled: "inputDisabled", initialSelectedDate: "initialSelectedDate" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [["templateRef", ""], [1, "panel-action"], ["data-test-id", "Prev Button", 1, "btn", "btn-secondary", 3, "click", "ngClass"], ["ycnIcon", "", 3, "name"], ["data-test-id", "Month Dropdown", 3, "changeHandler", "customCssClasses", "selectedValue", "config", "inputDisabled"], ["data-test-id", "Year Dropdown", 3, "changeHandler", "customCssClasses", "selectedValue", "config", "inputDisabled"], ["data-test-id", "Next Button", 1, "btn", "btn-secondary", 3, "click", "ngClass"]], template: function HoldingsDatePickerInlineComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, HoldingsDatePickerInlineComponent_ng_template_0_Template, 9, 18, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    } }, dependencies: [i1.NgClass, i2.SingleSelectDropdownComponent, i3.IconDirective], encapsulation: 2 });
